import { IndexedDbModel } from '../../../shared/indexedDb/indexedDb.model';

export class PermissionIndexedDbModel extends IndexedDbModel {
  public static permissions: PermissionIndexedDbModel[] = [];

  /**
   * Load current permissions in static cache
   */
  public static async loadPermissions(): Promise<void> {
    PermissionIndexedDbModel.permissions = await PermissionIndexedDbModel.query().toArray();
  }

  /**
   * Get the permission by name
   *
   * @param name - the name of the permission
   *
   * @return the permission
   */
  public static getByName(name: string): PermissionIndexedDbModel | undefined {
    if (!PermissionIndexedDbModel.permissions) {
      return undefined;
    }

    return PermissionIndexedDbModel.permissions.find(module => module.name === name);
  }
  // Configuration
  public entity = 'permission';
  public table = 'permissions';
  public schema = '++id, module_id';
  public sync = false;

  // Fields
  public module_id: number;
  public name: string;
  public assignable_by_tenant: boolean;

  // Constructor
  constructor(attributes: Partial<PermissionIndexedDbModel>) {
    super(attributes);
  }
}
